import categoryStyle from './category.module.css'


export default function Category({ category, onClick, children }) {
    return <div className={categoryStyle.category} onClick={e => onClick(category._id)} >
        {children}
    </div>
}